import { render, staticRenderFns } from "./VaultTransferToCBNForm.vue?vue&type=template&id=06329bbc&scoped=true&"
import script from "./VaultTransferToCBNForm.vue?vue&type=script&lang=js&"
export * from "./VaultTransferToCBNForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06329bbc",
  null
  
)

export default component.exports